
// Packages
import { defineComponent } from 'vue';

// Helpers
import { getAppVariable } from '@white-label-helper/get-app-variable';
import { ACCOUNT_URLS } from '@white-label-helper/switch-app';

// Types
import { CustomAuth0Settings } from '@white-label-types/auth';

export default defineComponent({
  computed: {
    customAuth0Settings(): CustomAuth0Settings {
      return {
        logo: getAppVariable('logo'),
        primaryColor: this.$theme.brand[100],
        pageBackground: this.$theme.brand[16],
        titleText: getAppVariable('partner_name'),
      }
    }
  },

  beforeUnmount() {
    window.removeEventListener('pageshow', this.onPageShow);
  },

  mounted() {
    this.redirect();

    // Add this listener to handle cases where the user navigates back to this page
    // using the browser's back/forward buttons. The 'mounted' hook doesn't run again
    // due to bfcache, so we need 'pageshow' to ensure we redirect correctly and
    // don't display a blank page. E.g when going back from change-password screen
    window.addEventListener('pageshow', this.onPageShow);
  },

  methods: {
    onPageShow(event: PageTransitionEvent) {
      // only run the redirect when the event comes from bfcache (back/forward browser button)
      if (event.persisted) {
        this.redirect();
      }
    },
    redirect() {
      if (this.$launchDarkly.variation('WL-FeatureControlPerPartnerEnableMyAccount') === false) {
        return this.$router.replace(ACCOUNT_URLS.SEARCH_BOOKING)
          // eslint-disable-next-line no-console
          .catch((e) => console.error(e));
      }

      const auth0RedirectUrl = localStorage.getItem('passwordUpdateUrl');

      if (auth0RedirectUrl) {
        localStorage.removeItem('passwordUpdateUrl');
        return window.location.assign(auth0RedirectUrl);
      }

      return this.$auth.login(this.customAuth0Settings);
    },
  },

  render(createElement) {
    return createElement('div');
  },
});
